module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      danger: _vm.user.authenticated
    },
    attrs: {
      "id": "header"
    }
  }, [_c('img', {
    attrs: {
      "id": "header-img",
      "src": "/static/configuration/logos.gif"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "title"
    }
  }, [(!_vm.isMobile) ? _c('h1', {
    class: {
      hasSubtitle: _vm.$te('banner.subtitle')
    }
  }, [_vm._v(_vm._s(_vm.$t("banner.title")))]) : _vm._e(), _vm._v(" "), (!_vm.isMobile && _vm.$te('banner.subtitle')) ? _c('h2', [_vm._v(_vm._s(_vm.$t("banner.subtitle")))]) : _vm._e(), _vm._v(" "), (_vm.isMobile) ? _c('div', {
    staticClass: "title-div",
    class: {
      hasSubtitle: _vm.$te('banner.subtitle')
    }
  }, [_vm._v(_vm._s(_vm.$t("banner.title")))]) : _vm._e(), _vm._v(" "), (_vm.isMobile && _vm.$te('banner.subtitle')) ? _c('div', {
    staticClass: "subtitle-div"
  }, [_vm._v(_vm._s(_vm.$t("banner.subtitle")))]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "user-button"
    }
  }, [_c('div', {
    attrs: {
      "id": "user-icon-container"
    },
    on: {
      "click": _vm.toggleUserPanel
    }
  }, [(_vm.isMobile) ? _c('icon', {
    staticClass: "user-icon",
    class: {
      'icon-active': _vm.showUserPanel
    },
    attrs: {
      "name": "slms-user"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showUserPanel) ? _c('div', {
    staticClass: "transparent-panel user-panel"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("banner.languages")) + ":")]), _vm._v(" "), _vm._l((_vm.languages), function(language) {
    return _c('div', {
      key: language.id,
      on: {
        "click": function($event) {
          return _vm.setLanguage(language.id)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": language.id === _vm.selectedLanguage ? 'dot-circle-o' : 'circle'
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(language.label))])], 1)
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "admin-button"
    },
    on: {
      "click": _vm.adminButtonClick
    }
  }, [_c('icon', {
    attrs: {
      "name": !_vm.user.authenticated ? 'slms-login' : 'slms-logout'
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(!_vm.user.authenticated ? 'Admin' : 'Logout'))])], 1)], 2) : _vm._e()]), _vm._v(" "), (!_vm.isMobile && _vm.languages.length > 1) ? _c('ul', {
    staticClass: "buttons",
    attrs: {
      "id": "languageLinks"
    }
  }, _vm._l((_vm.languages), function(language) {
    return _c('li', {
      key: language.id
    }, [(language.id === _vm.selectedLanguage) ? _c('span', {
      attrs: {
        "href": '?lang=' + language.id
      }
    }, [_vm._v(_vm._s(language.label))]) : _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.setLanguage(language.id)
        }
      }
    }, [_vm._v(_vm._s(language.label))])])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.isMobile) ? _c('ul', {
    staticClass: "buttons",
    attrs: {
      "id": "tools"
    }
  }, [(!_vm.user.authenticated) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.showLoginDialog(true)
      }
    }
  }, [_vm._v("Admin")])]) : _c('li', [_c('a', {
    attrs: {
      "id": "logout-button",
      "href": "#"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.enableFeedback($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("banner.feedback")))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.enableUpload($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("banner.uploadKml")))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggleMeasure($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("banner.measure")))])]), _vm._v(" "), (_vm.enablePrint) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.printMap($event)
      }
    }
  }, [_vm._v("PDF")])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd5c3c7a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Banner.vue
// module id = 626
// module chunks = 2